import {createAction} from "redux-act";
import {LanguageType} from "modules";
import {INameByLang} from "modules/types";

export interface IHelpPagesItem {
	id: number;
	title: string;
	text: string;
	lang: LanguageType;
}

export interface IHelpPages {
	guidelines: Array<IHelpPagesItem>;
	terms: Array<IHelpPagesItem>;
	privacy: Array<IHelpPagesItem>;
	howToPlay: Array<IHelpPagesItem>;
	prizes: Array<IHelpPagesItem>;
}

export const fetchHelpPagesJson = createAction();
export const fetchHelpPagesJsonSuccess = createAction<IHelpPages>();
export const fetchHelpPagesJsonFailed = createAction();

export interface IFaq {
	id: string;
	title: INameByLang;
	text: INameByLang;
}

export const fetchFAQJson = createAction();
export const fetchFAQJsonSuccess = createAction<IFaq[]>();
export const fetchFAQJsonFailed = createAction();

export interface IApiErrorResponse {
	code: number;
	message: string;
	statusText: string;
}

export const fetchAllHelpPages = createAction();
export const fetchAllHelpPagesSuccess = createAction();
